// @mui
import { GlobalStyles as MUIGlobalStyles } from "@mui/material";

// ----------------------------------------------------------------------

export default function GlobalStyles() {
	const inputGlobalStyles = (
		<MUIGlobalStyles
			styles={{
				"*": {
					boxSizing: "border-box",
					"WebkitTapHighlightColor": "rgba(0, 0, 0, 0)",
					"MozTapHighlightColor": "transparent",
				},
				html: {
					margin: 0,
					padding: 0,
					width: "100%",
					height: "100%",
					WebkitOverflowScrolling: "touch",
				},
				body: {
					margin: 0,
					padding: 0,
					width: "100%",
					height: "100%",
				},
				"#root": {
					width: "100%",
					height: "100%",
				},
				input: {
					"&[type=number]": {
						MozAppearance: "textfield",
						"&::-webkit-outer-spin-button": {
							margin: 0,
							WebkitAppearance: "none",
						},
						"&::-webkit-inner-spin-button": {
							margin: 0,
							WebkitAppearance: "none",
						},
					},
				},
				textarea: {
					resize: "none",
					height: "unset !important",
					minHeight: 90,
					width: "100%",
					padding: 16,
					fontSize: 16,
					lineHeight: "calc(24/16)",
					fontWeight: 400,
					fontFamily: "General Sans",
					borderRadius: 8,
					color: "#22031F",
					appearance: "none",
					outline: "none",
					"&::placeholder": {
						color: "#9CA4AB",
					},
					"&:focus": {
						border: "2px solid #789b73",
					},
				},
				img: {
					display: "block",
					maxWidth: "100%",
				},
				ul: {
					margin: 0,
					padding: 0,
				},
			}}
		/>
	);

	return inputGlobalStyles;
}
